// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"EV","productsContainer":"FV","searchVerticalReco":"GV","heading":"HV"};